import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

// Layouts
import AdminLayout from '../layouts/AdminLayout'

// Pages
import AdminLogin from '../pages/AdminLogin'
import Models from '../pages/Models'
import ServiceProviders from '../pages/ServiceProviders'
import CreditMaintenance from '../pages/CreditMaintenance'
import CreditBalance from '../pages/CreditBalance'
import CreditTransaction from '../pages/CreditTransaction'
import Currency from '../pages/Currency'
import PricingManagement from '../pages/PricingManagement'
import SubscriptionManagement from '../pages/SubscriptionManagement'
import ContactLeads from '../pages/ContactLeads'
import Organisations from '../pages/Organisations'
import OrganisationDetail from '../pages/OrganisationDetail'
import OrganisationWorkflowConfigDetail from '../pages/OrganisationWorkflowConfigDetail'
import OrganisationWorkflowLeads from '../pages/OrganisationWorkflowLeads'

// Components
import ProtectedRoute from './ProtectedRoute'

// Route definitions
export const routes = [
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/admin/models" replace />
      },
      {
        path: 'models',
        element: (
          <ProtectedRoute requireAuth={true}>
            <Models />
          </ProtectedRoute>
        )
      },
      {
        path: 'service-providers',
        element: (
          <ProtectedRoute requireAuth={true}>
            <ServiceProviders />
          </ProtectedRoute>
        )
      },
      {
        path: 'currency',
        element: (
          <ProtectedRoute requireAuth={true}>
            <Currency />
          </ProtectedRoute>
        )
      },
      {
        path: 'pricing-management',
        element: (
          <ProtectedRoute requireAuth={true}>
            <PricingManagement />
          </ProtectedRoute>
        )
      },
      {
        path: 'subscription-management',
        element: (
          <ProtectedRoute requireAuth={true}>
            <SubscriptionManagement />
          </ProtectedRoute>
        )
      },
      {
        path: 'contact-leads',
        element: (
          <ProtectedRoute requireAuth={true}>
            <ContactLeads />
          </ProtectedRoute>
        )
      },
      {
        path: 'organisations',
        element: (
          <ProtectedRoute requireAuth={true}>
            <Organisations />
          </ProtectedRoute>
        )
      },
      {
        path: 'organisations/:organisationId',
        element: (
          <ProtectedRoute requireAuth={true}>
            <OrganisationDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'organisations/:organisationId/workflow-configs/:workflowConfigId',
        element: (
          <ProtectedRoute requireAuth={true}>
            <OrganisationWorkflowConfigDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'organisations/:organisationId/workflows/:workflowId',
        element: (
          <ProtectedRoute requireAuth={true}>
            <OrganisationWorkflowLeads />
          </ProtectedRoute>
        )
      },
      {
        path: 'credit-maintenance',
        element: (
          <ProtectedRoute requireAuth={true}>
            <CreditMaintenance />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="/admin/credit-maintenance/balance" replace />
          },
          {
            path: 'balance',
            element: <CreditBalance />
          },
          {
            path: 'transactions',
            element: <CreditTransaction />
          }
        ]
      }
    ]
  },
  {
    path: '/admin/login',
    element: (
      <ProtectedRoute requireAuth={false}>
        <AdminLogin />
      </ProtectedRoute>
    )
  },
  {
    path: '/',
    element: <Navigate to="/admin/login" replace />
  },
  {
    path: '*',
    element: <Navigate to="/admin/login" replace />
  }
]

// Create router
export const router = createBrowserRouter(routes)

export default routes
